<ngx-spinner size="large" color="#fff" type="ball-spin-clockwise-fade-rotating">
</ngx-spinner>